<template>
   <div class="gens-paternitytesting">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380-13.jpg" />
             <h1 class="gens-title">{{$t('ContractText.Paternity_testing')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380-13.jpg"/>
            <div slot="title">{{$t('ContractText.Paternity_testing')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('Paternitytesting.paternitytesting_1')}}</div>
           <div class="tip_white">{{$t('Paternitytesting.paternitytesting_2')}}</div>
       </div>

        <div class="gens_result" style="padding-bottom:0!important;">
               <div class="gens_result_info" style="margin-bottom:0px !important">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Paternitytesting.paternitytesting_3')}}</div>
                       <div class="result_line"></div>
                   </div>
                  <div class="gens_content_first" style="margin-bottom:0px !important">
                      <div class="gens_content_first_left" style="width:65% !important;">
                         <div class="title_tip">{{$t('Paternitytesting.paternitytesting_4')}}</div>
                         <div class="title_tip">{{$t('Paternitytesting.paternitytesting_5')}}</div>
                      </div>
                      <div class="gens_content_first_right title_content_special" style="width:30%;margin-left:5px;">
                          <div class="gens_content_first_right_img " style="opacity:1 !important;">
                               <img src="../../assets/images/paternitytesting/PaternityTest-01.jpg" style="width:218px !important"/>
                          </div>
                      </div>
                  </div>
               </div>
        </div>

        <div class="paternitytesting">
               <div class="paternitytesting_info">
                  <div class="paternitytesting_first">
                      <div class="paternitytesting_left">
                          <div class="paternitytesting_left_img ">
                               <img src="../../assets/images/paternitytesting/dna-signature.jpg" />
                          </div>
                      </div>
                      <div class="paternitytesting_tip">
                            <div class="paternitytesting_text">{{$t('Paternitytesting.paternitytesting_6')}}</div>
                            <div class="paternitytesting_line"></div>
                            <div class="paternitytesting_cont">{{$t('Paternitytesting.paternitytesting_7')}}<strong>{{$t('Paternitytesting.paternitytesting_s')}}</strong></div>
                      </div>
                  </div>
                  
               </div>
        </div>

        <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('Paternitytesting.paternitytesting_8')}}</div>
                       <div class="result_line"></div>
                   </div>
                   <div class="gens_result_science">
                       <div class="science_item science_item_special">
                           <div class="science_item_img" id="science_one">
                               <img class="img_science img_science_specials" src="../../assets/images/paternitytesting/PaternityTest-05.jpg" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Paternitytesting.paternitytesting_9')}}</span>
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img" id="science_two">
                               <img class="img_science img_science_specials" src="../../assets/images/paternitytesting/PaternityTest_Artboard 4.jpg" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Paternitytesting.paternitytesting_10')}}</span>
                              
                           </div>
                       </div>
                        <div class="science_item science_item_special">
                           <div class="science_item_img" id="science_three">
                               <img class="img_science img_science_specials" src="../../assets/images/paternitytesting/PaternityTest-04.jpg" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_tip">{{$t('Paternitytesting.paternitytesting_11')}}</div>
                               <div class="abstract_tip">{{$t('Paternitytesting.paternitytesting_12')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special">
                           <div class="science_item_img" id="science_four">
                               <img class="img_science img_science_specials" src="../../assets/images/paternitytesting/PaternityTest_Artboard 3.jpg" alt />   
                           </div>
                           <div class="science_abstract">
                               <span class="abstract_tip">{{$t('Paternitytesting.paternitytesting_13')}}</span>
                           </div>
                       </div>
                       
                   </div>
               </div>
        </div>

        
        <div class="example_two">
            <div class="example_content">
                <div class="example_item">
                    <div class="example_item_tip">{{$t('Paternitytesting.paternitytesting_14')}}</div>
                    <div class="example_line"></div>
                    <div class="example_ul">
                        <ul>
                            <li>{{$t('Paternitytesting.paternitytesting_15')}}</li>
                            <li>{{$t('Paternitytesting.paternitytesting_16')}}</li>
                            <li>{{$t('Paternitytesting.paternitytesting_17')}}</li>
                            <li>{{$t('Paternitytesting.paternitytesting_18')}}</li>
                            <li>{{$t('Paternitytesting.paternitytesting_19')}}</li>
                        </ul>
                    </div>
                </div>
                <div class="example_item">
                    <div class="example_item_tip">{{$t('Paternitytesting.paternitytesting_20')}}</div>
                    <div class="example_line"></div>
                    <div class="ad">{{$t('Paternitytesting.paternitytesting_21')}}</div>
                </div>
            </div>
        </div>
     
       
       

       <div class="gens_last_bottom">
            <div class="gens_last_bottom_content">
                <div class="gens_last_bottom_content_tip">{{$t('Paternitytesting.paternitytesting_22')}}</div>
                <div class="gens_last_bottom_content_tip_line"></div>
                <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('Paternitytesting.paternitytesting_23')}}</div>
                        <div class="contents_cont">{{$t('Paternitytesting.paternitytesting_24')}}</div>
                    </div>
                </div>
               <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('Paternitytesting.paternitytesting_25')}}</div>
                        <div class="contents_cont">{{$t('Paternitytesting.paternitytesting_26')}}</div>
                    </div>
                </div>
                <div class="gens_last_bottom_content_descript">
                    <i class="icon iconfont iconyinhao yinhao"></i>
                    <div class="contents">
                        <div class="contents_tip">{{$t('Paternitytesting.paternitytesting_27')}}</div>
                        <div class="contents_cont">{{$t('Paternitytesting.paternitytesting_28')}}</div>
                    </div>
                </div>
            </div>
        </div>
        
       

      
   
   </div>
</template>
<script>
import banner from '@/components/banner'
export default {
    data(){
        return{
           showInfoDetail:false,
        }
    },
    components: {
      banner,
     
    },
    mounted(){
        $(window).scroll(function(){ //滚动某位置 动画特效
            // var box = document.querySelector(".gens_content_first_right_img");
            // if( box!=null&&$(window).scrollTop()>(box.offsetTop - box.offsetHeight)){
            //     $('.gens_content_first_right_img').addClass('opacity');//这里840代表要动画的元素离最顶层的距离，console.log一下就知道了。
            //     $('.gens_content_first_right_img').addClass('rightturnleft');
            // }
            // var box_one= document.querySelector(".img_img_left");
            // if($(window).scrollTop() > (box_one.offsetTop - box_one.offsetHeight)){
            //     $('.img_img_right').addClass('opacity');
            //     $('.text_left_content').addClass('opacity');
            //     $('.text_right_content').addClass('opacity');
            //     $('.img_img_left').addClass('opacity');
                
            // }
            // var box_two= document.querySelector(".science_item_img");
            // if($(window).scrollTop() > (box_two.offsetTop - box_two.offsetHeight)){
            //     $('.science_item_img').addClass('opacity');
            // }
            var box = document.querySelector(".paternitytesting");
            if( box!=null&&$(window).scrollTop()>(box.offsetTop - box.offsetHeight)){
                $('.paternitytesting_left_img').addClass('two_transfer');
                $('#science_one').addClass('one_transfer');
                $('#science_two').addClass('two_transfer');
                $('#science_three').addClass('three_transfer');
                $('#science_four').addClass('four_transfer');
            }
            
            var box_three= document.querySelector(".people_tops");
            if( box_three!=null&&$(window).scrollTop() > (box_three.offsetTop - box_three.offsetHeight)){
                $('.info_left_img_item').addClass('opacity');
                $('#one').addClass('one_transfer');
                $('#two').addClass('two_transfer');
                $('#three').addClass('three_transfer');


                $('.info_right_img_info').addClass('opacity');
                $('.info_right_img_info').addClass('four_transfer');
                
            }
            // var box_four= document.querySelector(".gens_content_img");
            // if($(window).scrollTop() > (box_four.offsetTop - box_four.offsetHeight)){
            //     $('.gens_content_img').addClass('opacity');
            // }
            var box_five= document.querySelector(".science_top");
            if( box_five!=null&&($(window).scrollTop()) > (box_five.offsetTop - box_five.offsetHeight)){
                $('#science_one').addClass('one_transfer');
                $('#science_two').addClass('two_transfer');
                $('#science_three').addClass('three_transfer');
                $('#science_four').addClass('four_transfer');

            }

            var box_six=document.querySelector(".gens_killer_content");
            if(box_six!=null&&($(window).scrollTop()) > (box_six.offsetTop - box_six.offsetHeight)){
                 $('.killer_img_one').addClass('one_transfer');
                 $('.killer_img_two').addClass('rightturnleft');

            }
            
            
        })
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

  @import '../../assets/font/iconfont.css';
 @import '../../assets/css/animation.css';
.gens-paternitytesting{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    

    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width: 100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens_header_tip{
        background-color: #e699b2;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #cb3439;
            text-shadow: 1px 1px 2px #ffffff;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #cb3439;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_result{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .result_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
            
            .gens_transparent_content_info{
                margin-bottom: 10px;
               
                .mytick{
                    color: #244b6b;;
                    background: 0 0;
                    border: 0;
                    font-size: 18px;
                    height: 16px;
                    width: 16px;
                    display: inline-block;
                    position: relative;
                    border:2px solid #244b6b;;
                }
                .mytick:before,.mytick:after {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    color: #244b6b;;
                    border: 2px solid #244b6b;;
                    background-color: white;
                }
                .mytick:before {
                    width: 1px;
                    height: 0px;
                    left: 18%;
                    top: 46%;
                    transform: skew(0deg, 50deg);
                }
                .mytick:after {
                    width: 11px;
                    height: 0px;
                    left: 38%;
                    top: 15%;
                    transform: skew(0deg, -50deg);
                }

                .tick_text{
                    line-height: 27px;
                    font-weight: 400;
                    margin: 0 0 0px;
                    padding: 0 0 0 18px;
                    position: relative;
                    color: #3a3a3a;
                    font-size: 16px;
                    margin-bottom: -12px;
                }
            }
             .gens_content_first{
                
                 display: flex;
                 justify-content: flex-start;
                 flex-direction: row;
                 margin-bottom:30px;
                 
                 .gens_content_first_left{
                        width:66.66%;
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:30px;
                        margin-right: 30px;
                        .title_tip{
                            margin-bottom:30px;
                        }
                        .title_content{
                            display: flex;
                            flex-direction: row;
                            margin-bottom: 20px;
                            .title_content_imgs{
                                display: inline-block;
                                position: relative;
                                z-index: 2;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width:130px;
                                }
                            }
                            .titel_content_right{
                                margin-left:20px;
                                .title_number{
                                    font-size: .5em;
                                    vertical-align: super;
                                }
                            }

                        }
                         .title_content_tip_bottom{
                                color: #cb3439 !important;
                                font-size: 20px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.375em;
                                letter-spacing: .07em!important;
                                
                        }
                        .title_content_special{
                            margin-left:-80px !important;
                        }
                 }
                 .gens_content_first_right{
                     width:27.33%;
                     text-align: center;
                     .gens_content_first_right_img{
                         opacity: 0;
                         margin-top:-60px;
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                       
                         img{
                             height: auto;
                             max-width: 100%;
                             width:600px;
                         }
                     }
                     
                 }
             }

            .gens_result_info_imgs{
                // margin-bottom:30px;
                // display: inline-block;
                // vertical-align: top;
                // max-width: 100%;
                // img{
                //     vertical-align: middle;
                //     height: auto;
                //     max-width: 100%;
                // }
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                width:86%;
                .gens_result_info_left_img{
                    width:50%;
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: column;
                    .info_left_img_item{
                        padding-bottom: 10px!important;
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        opacity:0;
                        img{
                            height: auto;
                            max-width: 100%;
                            width: 731px;
                        }
                    }
                    
                    
                }
                .gens_result_info_right_img{
                    width:50%;
                    display: flex;
                    justify-items: center;
                    text-align: center;
                    .info_right_img_info{
                        width:100%;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        opacity: 0;
                            .right_imgs{
                                display: inline-block;
                                vertical-align: top;
                                max-width: 100%;
                                position: absolute;
                            img{
                                height: auto;
                                max-width: 100%;
                                vertical-align: middle;
                                width: 417px;
                            }
                        }
                    }
                    .four_transfer{
                         animation-duration: 2s !important;
                        -webkit-animation-duration:2s !important;
                        animation-fill-mode: both !important;
                        -webkit-animation-fill-mode: both !important;
                        transition-delay: 2s;
                        animation-delay: 2s;
                        animation: fadeInUpLeft  .7s 1 ease-in-out;
                    }
                }
                
            }

            .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                  box-sizing: border-box;
                  margin:0 50px 0 0px;
                  width: 100%;
                   padding:0 16px 0 0;
                  padding-bottom:30px;
                  padding-top:30px;
                 .science_item{
                    width:14.6%;
                    text-align: left;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;
                        opacity: 0;
                        -webkit-transition: opacity .8s ease 0s;
                        
                        transition-delay: .4s;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:300px !important;
                        }
                        
                    }
                    .science_item_img_one{
                        transition-delay: .2s;
                    }
                    .science_item_img_two{
                        transition-delay: .4s;
                    }
                    .science_item_img_three{
                        transition-delay: .6s;
                    }
                    .science_item_img_four{
                        transition-delay: .8s;
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 5px 0px 6px 0px;
                         text-align: center;
                        .abstract_tip{
                            color: #cb3439;
                            font-size:24px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            letter-spacing: 1px;
                            text-align: center;
                        }
                        .abstract_tip_special{
                            font-size:24px !important;
                        }
                        .ab_special{
                            text-align: center;
                        }
                        .abstract_line{

                        }
                        .abstract_content_one{
                            ul{
                                list-style-position: inside;
                                line-height: 27px;
                                letter-spacing: .07em!important;
                                color: #3b3b3b;
                                font-weight: 400;
                                font-size: 16px;
                                padding-inline-start: 0px !important;
                            }
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                        .abstract_content{
                            color: #999999;
                            font-size: 16px;
                            line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                            letter-spacing: .07em!important;
                            margin-top: 24px;
                        }
                    }

                 }
                 #science_one,#science_two,#science_three,#science_four{
                     opacity: 0 ;
                 }
                 .science_item_special{
                    padding-left: 15px;
                    padding-right: 16px;
                    width:225px !important;
                    .img_science_specials{
                            width:225px !important;
                    }
                }
                .science_item_special_std{
                    width:225px !important;
                    .img_science_specials{
                            width:225px !important;
                    }
                }
             }

             .gens_result_science_special{
                 width:85% !important;
             }
             

        }
        .tip_category{
            width:1200px;
            margin:auto;
            margin-bottom:15px;
            color: #3a3a3a;
            font-size: 16px;
            line-height: 24px;
            font-style: normal;
            font-weight: 400;
            letter-spacing: 0.07em !important;
        }
         .gens_list{

             display:flex;
             width:1200px;
             margin:auto;
             justify-content: flex-start;
             text-align: left;
             flex-direction: row;
             flex-wrap: wrap;
             margin-bottom:30px;
             .gens_list_item{
                 width:33.33%;
                 display: flex;
                 flex-direction: column;
                 .gens_list_item_single{
                     display:flex;
                     flex-direction: row;
                     margin-bottom:18px;
                    .gens_list_item_img{
                        display: inline-block;
                        position: relative;
                        z-index: 2;
                        img{
                            max-width: 100%;
                            height: auto;
                            width:52px;
                        }
                    }
                    .gens_list_item_content{
                        padding: 0 0 0 20px;
                        .gens_list_item_tip{
                            color: #cb3439;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.571428571428571em;
                                                    
                            letter-spacing: 1px;
                        }
                        .gens_list_item_abstract{
                            font-size: 14px;
                            line-height: 24px;
                            color: #3a3a3a;
                            font-style: normal;
                            font-weight: 400;
                        }
                    }
                 }
             }
         }
         
    }
    .science_top{

    }

    .gens_result_people{
        background-color: rgba(207,213,227,0.2) !important;
    }
    .people_tops{

    }
   
   
    .gens_result_second{
         background-color: rgba(192,227,221,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_second_info{
             width:1200px;
             margin:auto;
             .gens_result_second_info_tip{
                 .gens_result_second_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_result_second_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .gens_result_second_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
               
             }

             .gens_result_second_content{
                 text-align: center;
                 .content_info{
                     display:flex;
                     justify-content: center;
                     align-items: center;
                     flex-direction: column;
                     .content_info_item{
                         width:1200px;
                         display: flex;
                         justify-content: center;
                         flex-direction: row;
                         .text_left{
                             padding:0 60px;
                             width:50%;
                             .text_left_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: right;
                             }
                             .text_left_content{
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: right;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }
                         .line_down{
                             display:flex;
                             flex-direction: column;
                             justify-content: center;
                             width: 20px;
                             padding-top:60px;
                             position: relative;
                             .circle{
                                 position:absolute;
                                background: #fff;
                                background-color: #5ec3b5;
                                box-sizing: border-box;
                                border: 1px solid transparent;
                                border-radius: 50%;
                                content: "";
                                height: 18px;
                                left: 50%;
                                margin: 0 0 0 -9px;
                                position: absolute;
                                top:20px;
                                width: 18px;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.68) .5s;

                             }
                             .vertical{
                                background-color: #5ec3b5;
                                height: 100%;
                                left: 50%;
                                margin-left: -1px;
                                position: absolute;
                                width: 2px;
                             }
                         }
                         .img_right{
                             width:50%;
                             margin-left:-10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_right{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: left;
                                box-sizing: border-box;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                             
                         }
                         .img_left{
                             width:50%;
                             margin-left:10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_left{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: right;
                                box-sizing: border-box;
                                margin-right:-10px;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                         }
                           .text_right{
                             width:50%;
                             text-align: left;
                             padding:0 0px;
                             .text_right_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: left;
                                padding-left:60px;
                             }
                            .text_right_content{
                                width:100%;
                                padding-left:60px;
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: left;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }

                     }
                 }
             }
        }
    }
    

    .gens_advice{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         
        .gens_content{
            width:1200px;
            margin:auto;
            display: flex;
            justify-content: left;
            flex-direction: row;

            .gens_content_left{
                width:66.66%;
                padding-right:15px;
                .left_tips{
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    color: #5ec3b5;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                    margin-bottom:24px;

                }
                .left_advice_content{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
            }
            .gens_content_right{
                width:33.33%;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                .gens_content_img{
                    animation: element-from-right .7s 1 ease-in-out;
                    opacity: 0;
                    img{
                        height: auto;
                        max-width: 100%;
                    }
                }
            }
        }
    }
    
    .gens_last_bottom{

        background-image: url(../../assets/images/paternitytesting/paternity-faq.jpg);
        background-position: 50% 111px;
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
        .gens_last_bottom_content{
            width:1200px;
            margin:auto;
            text-align: left;
            margin-bottom:60px;
            .gens_last_bottom_content_tip{
               color: #fff;;
               font-size: 28px;
               font-style: normal;
               font-weight: 700;
               text-transform: none;
               line-height: 1.384615384615385em;
               letter-spacing: 1px;
               margin-top:60px;
            }
            .gens_last_bottom_content_tip_line{
                margin-top: 10px;
                margin-bottom: 30px;
                background-color: #fff;;
                width: 250px;
                height: 2px;
                position: relative;

            }
            .gens_last_bottom_content_descript{
                display:flex;
                flex-direction: row;
                border-left:4px solid #e699b2;
                background-color: rgba(251,207,192,0.9);
                width:60.06%;
                padding-bottom:24px;
                margin-bottom:30px;
                padding: 14px 14px 14px 0px;
                .yinhao{
                    color: #e699b2;
                    font-size: 38px;
                    margin: 6px 0 0 12px !important;
                    display: inline-block;
                    font: normal normal normal 14px/1 FontAwesome;
                    letter-spacing: 0.07em !important;
                    font-weight: 900;
                }
                .contents{
                    margin-left:20px;
                   .contents_tip{
                        color: #cb3439;;
                        font-size: 21px;
                        line-height: 32px;
                        letter-spacing: 0px;
                        text-transform: none;
                        font-style: normal;
                        font-weight: 300;

                   }
                   .contents_cont{
                       color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                   }
                }
            }
            .gens_last_abstract{
                .abstract_stip{
                    font-size: 18px;
                    color: #fff;
                    font-weight: bold;
                    background-color: #00b0c0;
                    padding:0 10px;
                }
                .abstract_stip_special{
                    background-color: #e699b2 !important;
                }
                .abstract_content{
                    font-size: 16px;
                    padding-left:5px;
                }
            }
           
            .bottom_document_tip{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                margin-top:30px;
            }
            .bottom_document_cont{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                
            }
            .bottom_document_cont_last{
                margin-bottom:60px;
            }
            
            
        }
    }


    .gens_four_content{
             background-color: rgba(251,207,192,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_four_content_info{
             width:1200px;
             margin:auto;
             .gens_four_content_tip{
                 .gens_four_content_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_four_content_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }

            }
            .gens_four_detail{
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                width:90%;
                margin-bottom:30px;
                 .gens_four_detail_left{
                     width:66.66%;
                     display: flex;
                     justify-content: flex-start;
                     flex-direction: row;
                     flex-wrap: wrap;
                     .gens_four_item{
                         width:33.33%;
                         .gantanhao{
                             color: #cb3439;
                             font-size: 16px;
                             line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                         }
                         .four_detail_tip{
                             color: #cb3439;
                             font-size: 16px;
                             line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                         }
                     }
                }
                .gend_four_detail_right{
                    width: 33.33333333%;
                    text-align: center;
                    display: flex;
                    justify-content: flex-start;
                    margin-top:-90px;
                    .four_detai_img{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        img{
                            height: auto;
                            max-width: 100%;
                            vertical-align: middle;
                            width:150px;
                        }
                        .right_death{
                            text-align: center;
                            color: #cb3439;
                            font-size: 28px;
                            font-style: normal;
                            font-weight: 700;
                            text-transform: none;
                            .gantanhao{
                                color: #cb3439;
                                font-size: 28px;
                                font-style: normal;
                                font-weight: 700;
                                text-transform: none;
                            }
                        }
                    }
                }
            }
           
         }
    }


    .gens_killer_content{
        background-color: #fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_killer_content_info{
             width:1200px;
             margin:auto;
             .gens_killer_content_tip{
                 .gens_killer_content_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_killer_content_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }

            }

            .killer_content{
                width:90%;
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                text-align: center;
                margin-bottom: 20px;
                .killer_content_item{
                    width: 50%;
                    .killer_img{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        img{
                            height: auto;
                            max-width: 100%;
                            width:800px;
                        }
                    }
                    .killer_img_one,.killer_img_two{
                        opacity: 0 !important;
                    }
                    
                    .killer_tip{
                        text-align: center;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        text-transform: none;
                        color: #cb3439;
                        line-height: 1.304347826086957em;
                        letter-spacing: 1px;
                    }
                    .killer_content{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        letter-spacing: 0.07em !important;
                        display: flex;
                        justify-content: center;
                    }

                }
            }
         }
    }
     
    .gens_transparent_bk{
        height: 400px;
        background-image: url(../../assets/images/monogenicdisease/baby-feet.jpg);
        background-position: 50% 224px;
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
         .gens_transparent_bk_content{
             padding-top: 150px;
             padding-bottom: 150px;
             .gens_transparent_bk_tip{
                 text-align: center;
                 color: #ffffff;
                 font-size: 16px;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                 .bk_number{
                     font-size: .5em;
                    vertical-align: super;
                 }
             }
             .gens_transparent_bk_c{
                 margin-top:24px;
                color: #fff;
                font-size: 30px;
                line-height: 1.25em;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
             }
         }
    }

     

     .gens_example_analysis{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         .gens_example_analysis_info{
             width:1200px;
             margin:auto;
             .gens_example_analysis_info_tip{
                 .gens_example_analysis_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_example_analysis_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
             }

             .gens_analysis_content{
                 display: flex;
                 flex-direction: row;

                 .gens_analysis_left{
                     width:50%;
                     .gens_example_single{
                         width:1200px;
                        font-size: 18px;
                        color: #ffffff;
                        font-weight: bold;
                        background-color: #e699b2;
                        line-height: 24px;
                        font-style: normal;
                        letter-spacing: .07em!important;
                        margin-bottom:24px;

                    }
                    .gens_example_advice{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: .07em!important;
                        strong{
                            color: #cb3439;

                        }
                    }
                    .for_example{
                        margin-top:30px;
                        margin-bottom:30px;
                        padding: 14px 14px 14px 10px;
                        display:flex;
                        flex-direction: row;
                        border-left:4px solid #e699b2;
                        background-color: rgba(251,207,192,0.2);
                        width: 85%;
                        .yinhaos{
                            color: #e699b2;
                            font-size: 28px;
                            margin: 6px 0 0!important;
                        }
                        .for_example_content{
                            padding-left:40px;
                            font-size: 18px;
                            font-weight: 500;
                        }
                    }
                   
                 }
                 .gens_analysis_right{
                     width:40%;
                     margin-bottom: 30px;
                     margin-left:-60px;
                     .gens_analysis_right_img{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                         img{
                            height: auto;
                            max-width: 100%;
                            width:800px;
                         }
                     }
                 }
             }
             
             
         }
     }


     .paternitytesting{
             background-color: rgba(251,207,192,0.2);
            padding-top: 60px;
            padding-bottom: 30px;
            text-align: left;
         .paternitytesting_info{
             width:1200px;
            margin:auto;
             .paternitytesting_first{
                  display: flex;
                  flex-direction: row;
                 .paternitytesting_left{
                     width:30%;
                     margin-bottom: 30px;
                     .paternitytesting_left_img{
                             display: inline-block;
                            vertical-align: top;
                            max-width: 100%;
                            opacity: 0;
                         img{
                             height: auto;
                            max-width: 100%;
                            width:300px;
                         }
                     }
                 }
                 .paternitytesting_tip{
                     width:65%;
                     margin-left:5%;
                    .paternitytesting_text{
                        color: #e699b2;
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 700;
                        text-transform: none;
                        line-height: 1.384615384615385em;

                    }
                    .paternitytesting_line{
                        margin-top: 10px;
                        margin-bottom: 30px;
                        background-color: #e699b2;
                        width: 250px;
                        height: 2px;
                        position: relative;
                    }
                    .paternitytesting_cont{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: 0.07em !important;
                    }
                }
             }
            
        }    
             
    }
     

    .example_two{
        width:100%;
        background-color: #fff;
        padding-top: 60px;
        padding-bottom: 30px;
        text-align: left;
        .example_content{
            width:1200px;
            margin:auto;
            display:flex;
            flex-direction: row;
            .example_item{
                width:50%;
                text-align:left;
                .example_item_tip{
                    color:#e699b2;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                }
                .example_line{
                    margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                }
                .example_ul{
                    text-align: left;
                    ul{
                        margin:0 0;
                        padding:0 0;
                        list-style-position: inside;
                        line-height: 27px;
                        letter-spacing: 0.07em !important;
                        color: #3b3b3b;
                        font-weight: 400;
                        font-size: 16px;
                        overflow-y: hidden;
                        text-align: left;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
                .ad{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                }
            }
        }
    }
    

    

.opacity{
    opacity: 1 !important;
}

.special_result{
    background-color: rgba(251,207,192,0.2);
  
}
    

}
</style>

<style lang="scss">

.gens_results_right{
    .el-carousel__button{
        border-radius: 50% !important;
        width:12px !important;
        height: 12px !important;
    }
}
@-o-keyframes element-from-bottom{
    0%{-o-transform:translate(0,30%);opacity:0}
    100%{-o-transform:translate(0,0);opacity:1}
}
@-o-keyframes element-from-left{
    0%{
        -o-transform:translate(-20%,0);opacity:0}
    100%{
        -o-transform:translate(0,0);opacity:1}
}
</style>


// WEBPACK FOOTER //
// src/view/genedetection/paternitytesting.vue